import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Materials.types'

@Injectable({ providedIn: 'root' })
export class Materials_create_materials_flowService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { materials: $types.Materials.Material[] }): Promise<{ results?: any, materials?: any[], errors?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.materials)) {
      missingRequiredInParams.push('\'materials\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Materials/functions/create_materials_flow`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

